// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/contact.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/images/img-37.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=============================================================
                Home before login Css
===============================================================*/


.dark_section-pricing-view {
    background: #f2f2f2;
}
.howitworks .card_item {
    border-radius: 10px;
    text-align: center;
    position: relative;
    padding-top: 100px;
}
.home_course .item {
    background-color: #fff;
    flex-grow: inherit;
    flex-basis: auto;
    padding: 15px;
    border-radius: 5px;
}
.home_course .item a {
    background-color: #F0F1F7;
    display: block;
    padding: 15px 0px;
    text-decoration: none;
}
.home_course .item a img {
    width: 70%;
}
.home_course .item a h5 {
    margin-bottom: 0;
    color: #e32726;
    text-transform: uppercase;
    padding-top: 15px;
    font-size: 25px;
    font-weight: 600;
    font-family: 'Nunito Sans',sans-serif;
}
.home_course {
    justify-content: space-between;
}
.halftop_img {
    position: absolute;
    transform: translate(-50%, -110%);
    background-color: rgb(255, 255, 255);
    display: inline-block;
    width: 150px;
    height: 150px;
    line-height: 150px;
    left: 50%;
    box-shadow: rgb(203, 226, 239) 0px 2px 5px;
    border-radius: 50%;
}
.howitworks .card_footer {
    background-color: #c7c7c7;
    border-radius: 0 0 10px 10px;
}
.footer_copyright ul li{
    color: #000000;
}
.howitworks .card.card_item p{
    
    
    font-weight: 400;
    font-size: 17px;
    color: #191818;
    height: 180px;
}
.new-ds-login-home-banner-text{
    height: 350px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.new-ds-login-home-banner-text h1{
    
    font-size: 60px;
    font-weight: 600;
    color: #333333;
}

.new-ds-login-home-banner-text h1 span i{
    font-size: 20px;
    color: #cf2e22;
}
.head1{
    color: #333;
    font-size: 40px;
    text-transform: uppercase;
    
    font-weight: 600;

}
.new-ds-login-home-banner-text p{
    
    font-size: 17px;
    color: #333333;
}
section.pricing.pricing-bg {
    background-color: #ffffff !important;
  
}
section.pricing.pricing-bg h2{
    
    font-size: 40px;
    font-weight: 600;
    color: #333333;
}
section.pricing .pricing-views{
    background-color: transparent;
    background-image: linear-gradient(180deg,#ffffff 0%,#f1f4f9 100%);
    background-image: linear-gradient(180deg,#ffffff 0%,#f9f9f9 100%);
    padding-top: 10px;
    padding-bottom: 50px;
}
section.pricing .pricing-views .card{
    box-shadow: none;
    border-radius: 10px;
    border: none;
}
section.pricing .pricing-views .card:hover{
    box-shadow: 0 1px 10px 10px rgba(86,95,112,.1);
}
section.pricing .pricing-views .card h5{
    font-size: 23px;
    font-weight: 600;
    
    margin: 0px;
    padding: 18px 0px 13px 0px;
    color: #333333;
    background: #f2f2f2;
    padding: 20px 0px;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 0px;
    
    border-radius: 10px 10px 0px 0px;
}
section.pricing .pricing-views .card-body{
    padding:0px;
}
section.pricing .pricing-views .card-price{
    color: #333333;
    background: #f2f2f2;
    padding: 10px 0px;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 0px;
}
section.pricing .pricing-views .card-price b{
    font-weight: 600;
    font-size: 45px;
    
}
section.pricing .pricing-views .row-pricing{
    display: flex;
    justify-content: center;
    width: 100%;
    margin: auto;
    grid-gap: 30px;
}

section.pricing .pricing-views .btn{
    width: auto;
    font-size: 14px;
    display: inline-block;
    text-align: center;
    margin: auto;
    padding: 7px 40px;
    border-radius: 7px;
    letter-spacing: 0.5px;
    
    margin-top: 10px;
    margin-bottom: 30px;
    font-weight: 500;
    outline: 0px !important;
    box-shadow: none !important;
    color: #fff;
    background-color: #cf2e22 !important;
    border-color: #cf2e22 !important;
    opacity: 1;
}
section.pricing .pricing-views .btn span{
    
    font-weight: 500;
    font-size: 10px;
    color: #fff8f7;
    text-transform: capitalize;
    display: block;
}
section.pricing .pricing-views .row-pricing .col-lg-4.item.item-first .card{
    box-shadow: none;
    margin-top: 0px;
}
section.pricing .pricing-views .row-pricing ul.side-list-view{
    margin: 0px;
    padding: 0px;
    list-style-type: none;
    background: #f9f9f9;
    border-radius: 10px;
    margin-top: 66px;
    padding-top: 30px;
}
section.pricing .pricing-views .row-pricing ul.side-list-view li{
    margin: 0px;
    padding: 5px 10px;
    /*  */
    font-size: 15px;
    /* font-weight: 400; */
    color: #333333;
    text-align: right;
    font-weight: 600;
    font-family: 'Nunito Sans',sans-serif;
    height: 47px;

}
section.pricing .pricing-views ul.fa-ul{
    margin: 0px;
    padding: 0px;
    list-style-type: none;
    padding-top: 30px;
}
section.pricing .pricing-views ul.fa-ul li img{
   width: 25px;
}
section.pricing .pricing-views ul.fa-ul li{
    margin: 0px 20px;
    padding: 10px 15px;
    border-bottom: 1px solid #f3f3f3;
    text-align: center;
    height: 47px;
}
section.pricing .pricing-views ul.fa-ul li:last-child{
    border: 0px;
}
.contact-page-banner {
	height: 420px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
    background-position: 100% 50%;
    margin-top: -15px;
}
.contact-page-banner-layer{
    height: inherit;
    min-height: initial;
    width: 100%;
    position: absolute;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
}
.contact-page-banner-text{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    flex-direction: column;
    width: 50%;
    margin: auto;
}
.contact-page-banner-text h1{
    color: #ffffff;
    font-size: 56px;
    font-weight: bold;
    font-family: Roboto, sans-serif;
    text-align: center;
}
.contact-page-banner-text p{
    color: #ffffff;
    padding-top: 0.25em;
    padding-bottom: 0.25em;
    font-weight: normal;
    text-align: center;
    font-size: 20px;
}
section.pricing.pricing-another .pricing-views .row-pricing{
    display: flex;
   justify-content: center;
    width: 85%;
    margin: auto;
    grid-gap: 30px;
}
section.pricing.pricing-another .pricing-views ul.fa-ul{
    padding: 0px;
}
section.pricing.pricing-another .pricing-views ul.fa-ul li{
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}
section.pricing.pricing-another .pricing-views ul.fa-ul li a{
    margin: 0px;
    padding: 5px 10px;
    
    font-size: 15px;
    font-weight: 400;
    color: #333333;
}
section.pricing.pricing-another .pricing-views ul.fa-ul li a i{
    color: #018aeb;
}
.p-0-fource{
    padding: 0px !important;
}
p.pricing-bottom-btn{
    margin: 0px;
    /* margin-top: -17px; */
    position: relative;
    top: -15px;
}
p.pricing-bottom-btn a{
    font-size: 12px;
    color: #007bff;
    font-weight: 600;
}
.home_course .item a,
.home_course .item{
    background: #ffffff;
}
.home_course .item:hover {
    box-shadow: 0 1px 10px 10px rgba(86,95,112,.1);
}
.howitworks .card_footer{
    background-color: #f2f2f2;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px 5px 4px #cccccc;

}

.howitworks .card_footer h5{
    color: #333333;
}
.article-list.contact-feedback{
   padding-bottom: 40px;
}
.article-list.contact-feedback .item {
    padding-top: 50px;
    text-align: center;
}
.article-list.contact-feedback .item .name {
    font-weight: 700;
    font-size: 16px;
    margin-top: 20px;
    color: #e43126;

}
.article-list.contact-feedback .item .description {
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 0;
    color: #7d8285;
  
}
.contact-clean {
    padding: 40px 0;
    background-color: #f0f0f0;
}
.contact-clean form {
    max-width: 600px;
    width: 90%;
    margin: 0 auto;
    padding: 40px;
    border-radius: 4px;
    color: #505e6c;
}
.contact-clean h2 {
    margin-top: 5px;
    font-weight: 700;
    font-size: 28px;
    margin-bottom: 36px;
    color: inherit;
}
.contact-clean form .form-control {
    background: #fff;
    border-radius: 2px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, .05);
    outline: 0;
    color: inherit;
    padding-left: 12px;
    height: 42px;
}
.contact-clean .form-group:last-child {
    margin-bottom: 5px;
}
.contact-clean form .btn {
    padding: 16px 32px;
    border: none;
    background: 0 0;
    box-shadow: none;
    text-shadow: none;
    opacity: .9;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: .4px;
    line-height: 1;
    outline: 0!important;
}.contact-clean form .btn-primary {
    background-color: #e43126!important;
    margin-top: 15px;
    color: #fff;
}

.contact-clean form .form-control {
    background: #fff;
    border-radius: 2px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, .05);
    outline: 0;
    color: inherit;
    padding-left: 12px;
    height: 42px;
}
.contact-clean form textarea.form-control {
    min-height: 100px;
    max-height: 260px;
    padding-top: 10px;
    resize: vertical;
}
ul.fa-ul li .fa-ul-li-span{
    display: none;
}
.dark_section-pricing-view .iphoneX-view{
    display: flex;
    width: 100%;
    background: #fdfdfd;
    padding: 30px 20px;
    margin: 30px auto;
    border-radius: 40px;
    box-shadow: 0px 5px 4px #cccccc;
    justify-content: center;
    height: 500px;
}
.dark_section-pricing-view .iphoneX-view .item{
    width: 45%;
        text-align: center;
        /* height: 100%; */
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
}
.dark_section-pricing-view .iphoneX-view .item img{
    height: 100%;
}
.dark_section-pricing-view .iphoneX-view .item h1{
    font-size: 30px;
    color: #333;
    font-weight: 600;
    
    text-align: center;
}
.dark_section-pricing-view .iphoneX-view .item h2{
    font-size: 20px;
    text-align: center;
    color: #333;
    color: #1d9d43;
}
.pricing-bottom-box h1{
    
    font-size: 30px;
    font-weight: 600;
    color: #333333;
    text-align: center;
    margin-top: 25px;
}
.pricing-bottom-box h3{
    
    font-size: 20px;
    font-weight: 400;
    color: #8c8c8c;
    text-align: center;
    margin-bottom: 20px;
}
.pricing-bottom-box .main-view{
   display: flex;
}
.pricing-bottom-box .main-view .item{
    width: 30%;
    padding: 20px;
    border-radius: 10px;
    /* box-shadow: 0px 0px 4px #cccccc; */
    margin-right: 30px;
    background: #ffffff;
    position: relative;
 }
 .pricing-bottom-box .main-view .item:last-child{
     margin-right: 0px;
 }
 .pricing-bottom-box .main-view .item img{
    width: 100%;
    border-radius: 10px;
 }
 .pricing-bottom-box .main-view .item p{
    margin-top: 30px;
        text-align: center;
        
        font-size: 18px;
        font-size: 22px;
        line-height: 24px;
        color: #333333;
        position: absolute;
        font-weight: 500;
        top:30%;
        width: 100%;
        left: 0px;
 }
 .pricing-bottom-box .main-view .item p span{
    
    font-size: 18px;
    font-size: 22px;
    display: block;
 }
 .pricing-bottom-box .main-view .item:first-child p{
     top:27%;
     color: #ffffff;
 }
 .pricing-bottom-box .main-view .item:last-child p{
    color: #ffffff;
}
 p.contactus-more{
  text-align: center;
  margin: 40px 0px 20px 0px;
 }
 p.contactus-more a {
        color: #007bff;
        font-size: 16px;
        text-transform: capitalize;
}
@media (max-width:1199px){
    .pricing-bottom-box .main-view .item p {
        top: 26%;
     }
     .pricing-bottom-box .main-view .item:first-child p {
        top: 22%;
     }
}
@media (max-width:991px){
    section.pricing .pricing-views .card h5{
        font-size: 20px;
    }
    section.pricing .pricing-views .card-price b{
        font-size: 40px;
    }
    section.pricing .pricing-views .row-pricing {
       
        grid-gap: 15px;
    }
    section.pricing .pricing-views .row-pricing ul.side-list-view li{
        font-size: 12px;
    }
    section.pricing.pricing-bg h2{
        font-size: 30px;
    }
    .new-ds-login-home-banner-text h1{
        font-size: 50px;
    }
    .new-ds-login-home-banner-text{
        height: 250px;
    }
    .contact-page-banner {
        height: 320px;
        background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
        background-position: 50% 50%;
        margin-top: -15px;
    }
    .contact-page-banner-text{
        width: 80%;
    }
    .contact-page-banner-text h1{
        font-size: 45px;
    }
    section.pricing.pricing-another .pricing-views .row-pricing{
        width: 100%;
        grid-gap: 15px;
    }
    section.pricing .pricing-views ul.fa-ul li{
        padding: 10px 5px;
        margin: 0px 5px;
    }
    section.pricing.pricing-another .pricing-views ul.fa-ul li a{
        font-size: 13px;
    }
    .pricing-bottom-box .main-view .item p {
        font-size: 17px;
        line-height: 18px;
     }
     .pricing-bottom-box .main-view .item p span {
        font-size: 17px;
        line-height: 18px;
     }

}

@media (max-width:768px){
   
  
}

@media (max-width:767px){
    section.pricing .pricing-views .row-pricing {
        grid-template-columns: repeat(1, 1fr);
    }
    section.pricing .pricing-views .row-pricing ul.side-list-view li{
        text-align: center;
    }
    section.pricing.pricing-another .pricing-views .row-pricing{
        grid-template-columns: repeat(1, 1fr);
    }
    .new-ds-login-home-banner-text h1{
        font-size: 30px;
    }
    .new-ds-login-home-banner-text p{
        font-size: 13px;
    }
    .new-ds-login-home-banner-text{
        height: 140px;
    }
    .head1{
        font-size: 25px;
    }
    section.pricing .pricing-views ul.fa-ul li {
        margin: 0px 5px;
        padding: 10px 5px;
    }
    section.pricing.pricing-bg h2 {
        font-size: 25px;
        padding: 15px 25px !important;
    }
    .contact-page-banner-text h1 {
        font-size: 30px;
    }
    .contact-page-banner-text p{
        font-size: 13px;
        font-weight: 600;
    }
    .contact-page-banner{
        height: 210px;
    }
    .contact-clean form{
        padding: 15px;
    }
    section.pricing .pricing-views .row-pricing .col-lg-4.item.item-first{
        display: none;
    }
    ul.fa-ul li .fa-ul-li-span{
        display: inline-block;
        padding-right: 5px;
    }
    .dark_section-pricing-view .iphoneX-view{
        flex-direction: column;
        align-items: center;
        height: auto;
    }
    .dark_section-pricing-view .iphoneX-view .item img{
        width: 100%;
    }
    .dark_section-pricing-view .iphoneX-view .item{
        width: 100%;
        margin-bottom: 30px;
    }
    .pricing-bottom-box .main-view{
        flex-direction: column;
    }
    .pricing-bottom-box .main-view .item{
        width: 100%;
        margin: 0px;
        margin-bottom: 25px;
        text-align: center;
    }
    .pricing-bottom-box .main-view .item:last-child {
       margin-bottom: 0px;
    }
    .pricing-bottom-box .main-view .item img {
        height: auto;
        max-width: 250px;
    }   
    section.pricing .pricing-views .row-pricing .col-lg-3.col-md-3.item.item-first{
        display: none;
    }
    .pricing-bottom-box .main-view .item p {
        top: 30%;
        font-size: 21px;
        line-height: 23px;
     }
     .pricing-bottom-box .main-view .item:first-child p {
        top: 27%;
     }
     .pricing-bottom-box .main-view .item p span{
        font-size: 21px;
        line-height: 23px;
     }



}

.cursorDefault{
	cursor: default;
}
.smiliesCss{
	padding-top: 5px;
    width: 80px;
    text-align: center;
}
.smiliesCss.active{
  border: #2a874e 1px solid;
}

.home-top-box-view{
    margin-top: 100px;
}




/* .data-providers-page{

} */
.data-providers-page header{
  display: flex;
  align-items: center;
  margin-bottom: -75px;
  z-index: 999;
  position: relative;
  background: #fff;
  border-radius: 15px;
  padding: 30px;
}
.data-providers-page header .item{
  width: 50%;
}
.data-providers-page header h1{
  
  font-size: 30px;
  color: #1995ff;
  font-weight: 500;
}
.data-providers-page header p{
  
  font-size: 16px;
  color: #7b7b7b;
  font-weight: 400;
}
.data-providers-page .main-content{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 50% -227.2px;
  width: 100%;
  position: relative;
  background-color: #ccc;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.data-providers-page .main-content h1{
  
  font-size: 20px;
  color: #ffffff;
  font-weight: 500;
}
.data-providers-page .main-content p{
  
  font-size: 15px;
  color: #a2a2a2;
  font-weight: 400;
  margin-bottom: 0px;
}
.data-providers-page .overlay-colored {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}
.data-providers-page .section-content {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 120px 0;
  z-index: 1;
  background-attachment: fixed;
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
}
.data-providers-page .section-content .item{
  width: 75%;
  margin: auto;
  position: relative;
  margin-bottom: 40px;
}
.data-providers-page .section-content .item::after{
  position: absolute;
  width: 80%;
  background: red;
  height: 2px;
  content: "";
  border: 0;
  height: 1px;
  background: #a2a2a2;
  background-image: -webkit-linear-gradient(left, #1e1e1e, #a2a2a2, #1e1e1e);
  background-image: -moz-linear-gradient(left, #ccc, #333, #ccc);
  background-image: -ms-linear-gradient(left, #ccc, #333, #ccc);
  background-image: -o-linear-gradient(left, #ccc, #333, #ccc);
  width: 80%;
  margin: auto;
  left: 0px;
  right: 0px;
  bottom: -20px;
}
.data-providers-page .section-content .item:last-child::after{
  display: none;
}

@media(max-width:767px){
  .data-providers-page header{
    flex-direction: column-reverse;
  }
  .data-providers-page header .item{
    width: 100%;
  }
  .data-providers-page .section-content .item{
    width: 85%;
  }
  /* .data-providers-page .main-content p{
    /* text-align:justify; */
   
}`, "",{"version":3,"sources":["webpack://./app/pages/DestinationServicesStatic/pricing/home.css"],"names":[],"mappings":"AAAA;;gEAEgE;;;AAGhE;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;AACzC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,oCAAoC;IACpC,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,0CAA0C;IAC1C,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,cAAc;AAClB;AACA;;;IAGI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;AACjB;AACA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;;IAEzB,gBAAgB;;AAEpB;AACA;;IAEI,eAAe;IACf,cAAc;AAClB;AACA;IACI,oCAAoC;;AAExC;AACA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,iEAAiE;IACjE,iEAAiE;IACjE,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,8CAA8C;AAClD;AACA;IACI,eAAe;IACf,gBAAgB;;IAEhB,WAAW;IACX,0BAA0B;IAC1B,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;;IAElB,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;;AAEnB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;;IAErB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;IAC3B,WAAW;IACX,oCAAoC;IACpC,gCAAgC;IAChC,UAAU;AACd;AACA;;IAEI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,KAAK;IACL,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,YAAY;;AAEhB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;AACrB;AACA;GACG,WAAW;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;CACC,aAAa;CACb,4EAA2E;IACxE,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;AAChB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;GACd,uBAAuB;IACtB,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,iBAAiB;;IAEjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,8CAA8C;AAClD;AACA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,+BAA+B;;AAEnC;;AAEA;IACI,cAAc;AAClB;AACA;GACG,oBAAoB;AACvB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;;AAElB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;;AAElB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,oBAAoB;AACxB,CAAC;IACG,mCAAmC;IACnC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,+BAA+B;IAC/B,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,UAAU;QACN,kBAAkB;QAClB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,sBAAsB;QACtB,uBAAuB;AAC/B;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;;IAEhB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;AACA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;AACA;GACG,aAAa;AAChB;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;CACrB;CACA;KACI,iBAAiB;CACrB;CACA;IACG,WAAW;IACX,mBAAmB;CACtB;CACA;IACG,gBAAgB;QACZ,kBAAkB;;QAElB,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,OAAO;QACP,WAAW;QACX,SAAS;CAChB;CACA;;IAEG,eAAe;IACf,eAAe;IACf,cAAc;CACjB;CACA;KACI,OAAO;KACP,cAAc;CAClB;CACA;IACG,cAAc;AAClB;CACC;EACC,kBAAkB;EAClB,yBAAyB;CAC1B;CACA;QACO,cAAc;QACd,eAAe;QACf,0BAA0B;AAClC;AACA;IACI;QACI,QAAQ;KACX;KACA;QACG,QAAQ;KACX;AACL;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;;QAEI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,4EAA2E;QAC3E,4BAA4B;QAC5B,iBAAiB;IACrB;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,cAAc;IAClB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;KACpB;KACA;QACG,eAAe;QACf,iBAAiB;KACpB;;AAEL;;AAEA;;;AAGA;;AAEA;IACI;QACI,qCAAqC;IACzC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,qCAAqC;IACzC;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,6BAA6B;IACjC;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,WAAW;QACX,mBAAmB;QACnB,kBAAkB;IACtB;IACA;OACG,kBAAkB;IACrB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,QAAQ;QACR,eAAe;QACf,iBAAiB;KACpB;KACA;QACG,QAAQ;KACX;KACA;QACG,eAAe;QACf,iBAAiB;KACpB;;;;AAIL;;AAEA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;IACb,WAAW;IACX,kBAAkB;AACtB;AACA;EACE,yBAAyB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;;;;AAKA;;GAEG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yDAAyD;EACzD,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,WAAW;EACX,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,0EAA0E;EAC1E,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;EAC5D,UAAU;EACV,YAAY;EACZ,SAAS;EACT,UAAU;EACV,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;4BAC0B;;AAE5B","sourcesContent":["/*=============================================================\n                Home before login Css\n===============================================================*/\n\n\n.dark_section-pricing-view {\n    background: #f2f2f2;\n}\n.howitworks .card_item {\n    border-radius: 10px;\n    text-align: center;\n    position: relative;\n    padding-top: 100px;\n}\n.home_course .item {\n    background-color: #fff;\n    flex-grow: inherit;\n    flex-basis: auto;\n    padding: 15px;\n    border-radius: 5px;\n}\n.home_course .item a {\n    background-color: #F0F1F7;\n    display: block;\n    padding: 15px 0px;\n    text-decoration: none;\n}\n.home_course .item a img {\n    width: 70%;\n}\n.home_course .item a h5 {\n    margin-bottom: 0;\n    color: #e32726;\n    text-transform: uppercase;\n    padding-top: 15px;\n    font-size: 25px;\n    font-weight: 600;\n    font-family: 'Nunito Sans',sans-serif;\n}\n.home_course {\n    justify-content: space-between;\n}\n.halftop_img {\n    position: absolute;\n    transform: translate(-50%, -110%);\n    background-color: rgb(255, 255, 255);\n    display: inline-block;\n    width: 150px;\n    height: 150px;\n    line-height: 150px;\n    left: 50%;\n    box-shadow: rgb(203, 226, 239) 0px 2px 5px;\n    border-radius: 50%;\n}\n.howitworks .card_footer {\n    background-color: #c7c7c7;\n    border-radius: 0 0 10px 10px;\n}\n.footer_copyright ul li{\n    color: #000000;\n}\n.howitworks .card.card_item p{\n    \n    \n    font-weight: 400;\n    font-size: 17px;\n    color: #191818;\n    height: 180px;\n}\n.new-ds-login-home-banner-text{\n    height: 350px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.new-ds-login-home-banner-text h1{\n    \n    font-size: 60px;\n    font-weight: 600;\n    color: #333333;\n}\n\n.new-ds-login-home-banner-text h1 span i{\n    font-size: 20px;\n    color: #cf2e22;\n}\n.head1{\n    color: #333;\n    font-size: 40px;\n    text-transform: uppercase;\n    \n    font-weight: 600;\n\n}\n.new-ds-login-home-banner-text p{\n    \n    font-size: 17px;\n    color: #333333;\n}\nsection.pricing.pricing-bg {\n    background-color: #ffffff !important;\n  \n}\nsection.pricing.pricing-bg h2{\n    \n    font-size: 40px;\n    font-weight: 600;\n    color: #333333;\n}\nsection.pricing .pricing-views{\n    background-color: transparent;\n    background-image: linear-gradient(180deg,#ffffff 0%,#f1f4f9 100%);\n    background-image: linear-gradient(180deg,#ffffff 0%,#f9f9f9 100%);\n    padding-top: 10px;\n    padding-bottom: 50px;\n}\nsection.pricing .pricing-views .card{\n    box-shadow: none;\n    border-radius: 10px;\n    border: none;\n}\nsection.pricing .pricing-views .card:hover{\n    box-shadow: 0 1px 10px 10px rgba(86,95,112,.1);\n}\nsection.pricing .pricing-views .card h5{\n    font-size: 23px;\n    font-weight: 600;\n    \n    margin: 0px;\n    padding: 18px 0px 13px 0px;\n    color: #333333;\n    background: #f2f2f2;\n    padding: 20px 0px;\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 0px;\n    \n    border-radius: 10px 10px 0px 0px;\n}\nsection.pricing .pricing-views .card-body{\n    padding:0px;\n}\nsection.pricing .pricing-views .card-price{\n    color: #333333;\n    background: #f2f2f2;\n    padding: 10px 0px;\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 0px;\n}\nsection.pricing .pricing-views .card-price b{\n    font-weight: 600;\n    font-size: 45px;\n    \n}\nsection.pricing .pricing-views .row-pricing{\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin: auto;\n    grid-gap: 30px;\n}\n\nsection.pricing .pricing-views .btn{\n    width: auto;\n    font-size: 14px;\n    display: inline-block;\n    text-align: center;\n    margin: auto;\n    padding: 7px 40px;\n    border-radius: 7px;\n    letter-spacing: 0.5px;\n    \n    margin-top: 10px;\n    margin-bottom: 30px;\n    font-weight: 500;\n    outline: 0px !important;\n    box-shadow: none !important;\n    color: #fff;\n    background-color: #cf2e22 !important;\n    border-color: #cf2e22 !important;\n    opacity: 1;\n}\nsection.pricing .pricing-views .btn span{\n    \n    font-weight: 500;\n    font-size: 10px;\n    color: #fff8f7;\n    text-transform: capitalize;\n    display: block;\n}\nsection.pricing .pricing-views .row-pricing .col-lg-4.item.item-first .card{\n    box-shadow: none;\n    margin-top: 0px;\n}\nsection.pricing .pricing-views .row-pricing ul.side-list-view{\n    margin: 0px;\n    padding: 0px;\n    list-style-type: none;\n    background: #f9f9f9;\n    border-radius: 10px;\n    margin-top: 66px;\n    padding-top: 30px;\n}\nsection.pricing .pricing-views .row-pricing ul.side-list-view li{\n    margin: 0px;\n    padding: 5px 10px;\n    /*  */\n    font-size: 15px;\n    /* font-weight: 400; */\n    color: #333333;\n    text-align: right;\n    font-weight: 600;\n    font-family: 'Nunito Sans',sans-serif;\n    height: 47px;\n\n}\nsection.pricing .pricing-views ul.fa-ul{\n    margin: 0px;\n    padding: 0px;\n    list-style-type: none;\n    padding-top: 30px;\n}\nsection.pricing .pricing-views ul.fa-ul li img{\n   width: 25px;\n}\nsection.pricing .pricing-views ul.fa-ul li{\n    margin: 0px 20px;\n    padding: 10px 15px;\n    border-bottom: 1px solid #f3f3f3;\n    text-align: center;\n    height: 47px;\n}\nsection.pricing .pricing-views ul.fa-ul li:last-child{\n    border: 0px;\n}\n.contact-page-banner {\n\theight: 420px;\n\tbackground: url(/public/assets/images/contact.jpg) center / cover no-repeat;\n    background-position: 100% 50%;\n    margin-top: -15px;\n}\n.contact-page-banner-layer{\n    height: inherit;\n    min-height: initial;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.contact-page-banner-text{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n    flex-direction: column;\n    width: 50%;\n    margin: auto;\n}\n.contact-page-banner-text h1{\n    color: #ffffff;\n    font-size: 56px;\n    font-weight: bold;\n    font-family: Roboto, sans-serif;\n    text-align: center;\n}\n.contact-page-banner-text p{\n    color: #ffffff;\n    padding-top: 0.25em;\n    padding-bottom: 0.25em;\n    font-weight: normal;\n    text-align: center;\n    font-size: 20px;\n}\nsection.pricing.pricing-another .pricing-views .row-pricing{\n    display: flex;\n   justify-content: center;\n    width: 85%;\n    margin: auto;\n    grid-gap: 30px;\n}\nsection.pricing.pricing-another .pricing-views ul.fa-ul{\n    padding: 0px;\n}\nsection.pricing.pricing-another .pricing-views ul.fa-ul li{\n    height: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\nsection.pricing.pricing-another .pricing-views ul.fa-ul li a{\n    margin: 0px;\n    padding: 5px 10px;\n    \n    font-size: 15px;\n    font-weight: 400;\n    color: #333333;\n}\nsection.pricing.pricing-another .pricing-views ul.fa-ul li a i{\n    color: #018aeb;\n}\n.p-0-fource{\n    padding: 0px !important;\n}\np.pricing-bottom-btn{\n    margin: 0px;\n    /* margin-top: -17px; */\n    position: relative;\n    top: -15px;\n}\np.pricing-bottom-btn a{\n    font-size: 12px;\n    color: #007bff;\n    font-weight: 600;\n}\n.home_course .item a,\n.home_course .item{\n    background: #ffffff;\n}\n.home_course .item:hover {\n    box-shadow: 0 1px 10px 10px rgba(86,95,112,.1);\n}\n.howitworks .card_footer{\n    background-color: #f2f2f2;\n    border-radius: 0 0 10px 10px;\n    box-shadow: 0px 5px 4px #cccccc;\n\n}\n\n.howitworks .card_footer h5{\n    color: #333333;\n}\n.article-list.contact-feedback{\n   padding-bottom: 40px;\n}\n.article-list.contact-feedback .item {\n    padding-top: 50px;\n    text-align: center;\n}\n.article-list.contact-feedback .item .name {\n    font-weight: 700;\n    font-size: 16px;\n    margin-top: 20px;\n    color: #e43126;\n\n}\n.article-list.contact-feedback .item .description {\n    font-size: 14px;\n    margin-top: 15px;\n    margin-bottom: 0;\n    color: #7d8285;\n  \n}\n.contact-clean {\n    padding: 40px 0;\n    background-color: #f0f0f0;\n}\n.contact-clean form {\n    max-width: 600px;\n    width: 90%;\n    margin: 0 auto;\n    padding: 40px;\n    border-radius: 4px;\n    color: #505e6c;\n}\n.contact-clean h2 {\n    margin-top: 5px;\n    font-weight: 700;\n    font-size: 28px;\n    margin-bottom: 36px;\n    color: inherit;\n}\n.contact-clean form .form-control {\n    background: #fff;\n    border-radius: 2px;\n    box-shadow: 1px 1px 1px rgba(0, 0, 0, .05);\n    outline: 0;\n    color: inherit;\n    padding-left: 12px;\n    height: 42px;\n}\n.contact-clean .form-group:last-child {\n    margin-bottom: 5px;\n}\n.contact-clean form .btn {\n    padding: 16px 32px;\n    border: none;\n    background: 0 0;\n    box-shadow: none;\n    text-shadow: none;\n    opacity: .9;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 13px;\n    letter-spacing: .4px;\n    line-height: 1;\n    outline: 0!important;\n}.contact-clean form .btn-primary {\n    background-color: #e43126!important;\n    margin-top: 15px;\n    color: #fff;\n}\n\n.contact-clean form .form-control {\n    background: #fff;\n    border-radius: 2px;\n    box-shadow: 1px 1px 1px rgba(0, 0, 0, .05);\n    outline: 0;\n    color: inherit;\n    padding-left: 12px;\n    height: 42px;\n}\n.contact-clean form textarea.form-control {\n    min-height: 100px;\n    max-height: 260px;\n    padding-top: 10px;\n    resize: vertical;\n}\nul.fa-ul li .fa-ul-li-span{\n    display: none;\n}\n.dark_section-pricing-view .iphoneX-view{\n    display: flex;\n    width: 100%;\n    background: #fdfdfd;\n    padding: 30px 20px;\n    margin: 30px auto;\n    border-radius: 40px;\n    box-shadow: 0px 5px 4px #cccccc;\n    justify-content: center;\n    height: 500px;\n}\n.dark_section-pricing-view .iphoneX-view .item{\n    width: 45%;\n        text-align: center;\n        /* height: 100%; */\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n}\n.dark_section-pricing-view .iphoneX-view .item img{\n    height: 100%;\n}\n.dark_section-pricing-view .iphoneX-view .item h1{\n    font-size: 30px;\n    color: #333;\n    font-weight: 600;\n    \n    text-align: center;\n}\n.dark_section-pricing-view .iphoneX-view .item h2{\n    font-size: 20px;\n    text-align: center;\n    color: #333;\n    color: #1d9d43;\n}\n.pricing-bottom-box h1{\n    \n    font-size: 30px;\n    font-weight: 600;\n    color: #333333;\n    text-align: center;\n    margin-top: 25px;\n}\n.pricing-bottom-box h3{\n    \n    font-size: 20px;\n    font-weight: 400;\n    color: #8c8c8c;\n    text-align: center;\n    margin-bottom: 20px;\n}\n.pricing-bottom-box .main-view{\n   display: flex;\n}\n.pricing-bottom-box .main-view .item{\n    width: 30%;\n    padding: 20px;\n    border-radius: 10px;\n    /* box-shadow: 0px 0px 4px #cccccc; */\n    margin-right: 30px;\n    background: #ffffff;\n    position: relative;\n }\n .pricing-bottom-box .main-view .item:last-child{\n     margin-right: 0px;\n }\n .pricing-bottom-box .main-view .item img{\n    width: 100%;\n    border-radius: 10px;\n }\n .pricing-bottom-box .main-view .item p{\n    margin-top: 30px;\n        text-align: center;\n        \n        font-size: 18px;\n        font-size: 22px;\n        line-height: 24px;\n        color: #333333;\n        position: absolute;\n        font-weight: 500;\n        top:30%;\n        width: 100%;\n        left: 0px;\n }\n .pricing-bottom-box .main-view .item p span{\n    \n    font-size: 18px;\n    font-size: 22px;\n    display: block;\n }\n .pricing-bottom-box .main-view .item:first-child p{\n     top:27%;\n     color: #ffffff;\n }\n .pricing-bottom-box .main-view .item:last-child p{\n    color: #ffffff;\n}\n p.contactus-more{\n  text-align: center;\n  margin: 40px 0px 20px 0px;\n }\n p.contactus-more a {\n        color: #007bff;\n        font-size: 16px;\n        text-transform: capitalize;\n}\n@media (max-width:1199px){\n    .pricing-bottom-box .main-view .item p {\n        top: 26%;\n     }\n     .pricing-bottom-box .main-view .item:first-child p {\n        top: 22%;\n     }\n}\n@media (max-width:991px){\n    section.pricing .pricing-views .card h5{\n        font-size: 20px;\n    }\n    section.pricing .pricing-views .card-price b{\n        font-size: 40px;\n    }\n    section.pricing .pricing-views .row-pricing {\n       \n        grid-gap: 15px;\n    }\n    section.pricing .pricing-views .row-pricing ul.side-list-view li{\n        font-size: 12px;\n    }\n    section.pricing.pricing-bg h2{\n        font-size: 30px;\n    }\n    .new-ds-login-home-banner-text h1{\n        font-size: 50px;\n    }\n    .new-ds-login-home-banner-text{\n        height: 250px;\n    }\n    .contact-page-banner {\n        height: 320px;\n        background: url(/public/assets/images/contact.jpg) center / cover no-repeat;\n        background-position: 50% 50%;\n        margin-top: -15px;\n    }\n    .contact-page-banner-text{\n        width: 80%;\n    }\n    .contact-page-banner-text h1{\n        font-size: 45px;\n    }\n    section.pricing.pricing-another .pricing-views .row-pricing{\n        width: 100%;\n        grid-gap: 15px;\n    }\n    section.pricing .pricing-views ul.fa-ul li{\n        padding: 10px 5px;\n        margin: 0px 5px;\n    }\n    section.pricing.pricing-another .pricing-views ul.fa-ul li a{\n        font-size: 13px;\n    }\n    .pricing-bottom-box .main-view .item p {\n        font-size: 17px;\n        line-height: 18px;\n     }\n     .pricing-bottom-box .main-view .item p span {\n        font-size: 17px;\n        line-height: 18px;\n     }\n\n}\n\n@media (max-width:768px){\n   \n  \n}\n\n@media (max-width:767px){\n    section.pricing .pricing-views .row-pricing {\n        grid-template-columns: repeat(1, 1fr);\n    }\n    section.pricing .pricing-views .row-pricing ul.side-list-view li{\n        text-align: center;\n    }\n    section.pricing.pricing-another .pricing-views .row-pricing{\n        grid-template-columns: repeat(1, 1fr);\n    }\n    .new-ds-login-home-banner-text h1{\n        font-size: 30px;\n    }\n    .new-ds-login-home-banner-text p{\n        font-size: 13px;\n    }\n    .new-ds-login-home-banner-text{\n        height: 140px;\n    }\n    .head1{\n        font-size: 25px;\n    }\n    section.pricing .pricing-views ul.fa-ul li {\n        margin: 0px 5px;\n        padding: 10px 5px;\n    }\n    section.pricing.pricing-bg h2 {\n        font-size: 25px;\n        padding: 15px 25px !important;\n    }\n    .contact-page-banner-text h1 {\n        font-size: 30px;\n    }\n    .contact-page-banner-text p{\n        font-size: 13px;\n        font-weight: 600;\n    }\n    .contact-page-banner{\n        height: 210px;\n    }\n    .contact-clean form{\n        padding: 15px;\n    }\n    section.pricing .pricing-views .row-pricing .col-lg-4.item.item-first{\n        display: none;\n    }\n    ul.fa-ul li .fa-ul-li-span{\n        display: inline-block;\n        padding-right: 5px;\n    }\n    .dark_section-pricing-view .iphoneX-view{\n        flex-direction: column;\n        align-items: center;\n        height: auto;\n    }\n    .dark_section-pricing-view .iphoneX-view .item img{\n        width: 100%;\n    }\n    .dark_section-pricing-view .iphoneX-view .item{\n        width: 100%;\n        margin-bottom: 30px;\n    }\n    .pricing-bottom-box .main-view{\n        flex-direction: column;\n    }\n    .pricing-bottom-box .main-view .item{\n        width: 100%;\n        margin: 0px;\n        margin-bottom: 25px;\n        text-align: center;\n    }\n    .pricing-bottom-box .main-view .item:last-child {\n       margin-bottom: 0px;\n    }\n    .pricing-bottom-box .main-view .item img {\n        height: auto;\n        max-width: 250px;\n    }   \n    section.pricing .pricing-views .row-pricing .col-lg-3.col-md-3.item.item-first{\n        display: none;\n    }\n    .pricing-bottom-box .main-view .item p {\n        top: 30%;\n        font-size: 21px;\n        line-height: 23px;\n     }\n     .pricing-bottom-box .main-view .item:first-child p {\n        top: 27%;\n     }\n     .pricing-bottom-box .main-view .item p span{\n        font-size: 21px;\n        line-height: 23px;\n     }\n\n\n\n}\n\n.cursorDefault{\n\tcursor: default;\n}\n.smiliesCss{\n\tpadding-top: 5px;\n    width: 80px;\n    text-align: center;\n}\n.smiliesCss.active{\n  border: #2a874e 1px solid;\n}\n\n.home-top-box-view{\n    margin-top: 100px;\n}\n\n\n\n\n/* .data-providers-page{\n\n} */\n.data-providers-page header{\n  display: flex;\n  align-items: center;\n  margin-bottom: -75px;\n  z-index: 999;\n  position: relative;\n  background: #fff;\n  border-radius: 15px;\n  padding: 30px;\n}\n.data-providers-page header .item{\n  width: 50%;\n}\n.data-providers-page header h1{\n  \n  font-size: 30px;\n  color: #1995ff;\n  font-weight: 500;\n}\n.data-providers-page header p{\n  \n  font-size: 16px;\n  color: #7b7b7b;\n  font-weight: 400;\n}\n.data-providers-page .main-content{\n  background-image: url(\"/public/assets/images/img-37.jpg\");\n  background-position: 50% -227.2px;\n  width: 100%;\n  position: relative;\n  background-color: #ccc;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.data-providers-page .main-content h1{\n  \n  font-size: 20px;\n  color: #ffffff;\n  font-weight: 500;\n}\n.data-providers-page .main-content p{\n  \n  font-size: 15px;\n  color: #a2a2a2;\n  font-weight: 400;\n  margin-bottom: 0px;\n}\n.data-providers-page .overlay-colored {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 1;\n}\n.data-providers-page .section-content {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 120px 0;\n  z-index: 1;\n  background-attachment: fixed;\n  background-position: top center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.data-providers-page .section-content .item{\n  width: 75%;\n  margin: auto;\n  position: relative;\n  margin-bottom: 40px;\n}\n.data-providers-page .section-content .item::after{\n  position: absolute;\n  width: 80%;\n  background: red;\n  height: 2px;\n  content: \"\";\n  border: 0;\n  height: 1px;\n  background: #a2a2a2;\n  background-image: -webkit-linear-gradient(left, #1e1e1e, #a2a2a2, #1e1e1e);\n  background-image: -moz-linear-gradient(left, #ccc, #333, #ccc);\n  background-image: -ms-linear-gradient(left, #ccc, #333, #ccc);\n  background-image: -o-linear-gradient(left, #ccc, #333, #ccc);\n  width: 80%;\n  margin: auto;\n  left: 0px;\n  right: 0px;\n  bottom: -20px;\n}\n.data-providers-page .section-content .item:last-child::after{\n  display: none;\n}\n\n@media(max-width:767px){\n  .data-providers-page header{\n    flex-direction: column-reverse;\n  }\n  .data-providers-page header .item{\n    width: 100%;\n  }\n  .data-providers-page .section-content .item{\n    width: 85%;\n  }\n  /* .data-providers-page .main-content p{\n    /* text-align:justify; */\n   \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
